module.exports = new __parcel__URL__("mind-games.c1edc79c.jpg").toString();